module.exports = __webpack_public_path__ + "img/9788958281658.47a70f47.jpg";